import React, {useState} from "react";
import {Badge, Popover, PopoverBody, Button} from 'reactstrap';
import {Check,X} from "react-feather";
import API from "../../utils/API";
import {toastr} from "react-redux-toastr";

const OrderStatus = ({ id, status}) => {
    const statusMap = {
        active: { label: 'Active', color: 'success' },
        paused: { label: 'Paused', color: 'warning' },
        archive: { label: 'Archive', color: 'secondary' },
    };

    const [popoverOpen, setPopoverOpen] = useState(false);
    const [currentStatus, setCurrentStatus] = useState(status);

    const { label, color } = statusMap[currentStatus] || {};

    const toggle = () => setPopoverOpen(!popoverOpen);

    const changeStatus = (status) => {
        API.put('/admin/order/changestatus/'+id,{ status: status})
            .then((response) => {
                toastr.success('Success', `Order was successfully ${status === 'active' ? 'activated' : 'paused'}.`)
                setCurrentStatus(status);
                setPopoverOpen(false);
            });
    }

    return <>
        {label &&
            <>
                <Badge color={color} className="mr-1 mb-1 cursor-pointer" id={`order${id}`} onClick={toggle}>
                    {label}
                </Badge>
                {(status !== currentStatus) && <Check size={14}/>}
            </>
        }
        {popoverOpen &&
            <Popover placement="top" isOpen={popoverOpen} target={`order${id}`} toggle={toggle} trigger="legacy">
                <PopoverBody>
                    {currentStatus !== 'active' &&
                        <div className="d-flex justify-content-center mt-2">
                            <Button color="success" onClick={() => changeStatus('active')}>Activate</Button>
                        </div>
                    }
                    {currentStatus !== 'paused' &&
                        <div className="d-flex justify-content-center mt-2">
                            <Button color="warning" onClick={() => changeStatus('paused')}>Pause</Button>
                        </div>
                    }
                </PopoverBody>
            </Popover>
        }
    </>
};

export default OrderStatus;
